import React, { useState } from "react";
import "./index.css";

const Contactform = () => {
  const enquiryTabs = [
    "General Enquiry",
    "Export Enquiry",
    "Domestic Enquiry",
    "Product Support",
    "Partnership Request"
  ];

  const [activeTab, setActiveTab] = useState("General Enquiry");
  const [fname, setFname] = useState("");
  const [lname, setLname] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const formData = {
      enquiryType: activeTab,
      firstName: fname,
      lastName: lname,
      email,
      phone,
      message: msg
    };

    try {
      const res = await fetch("https://derbyb.ritaz.in/api/notifications/send-enquiry", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(formData)
      });

      if (!res.ok) {
        throw new Error(`HTTP error! Status: ${res.status}`);
      }

      const data = await res.json();
      console.log("API Response:", data);

    // Facebook Pixel - Track Contact
    if (typeof window.fbq === "function") {
      window.fbq("track", "Contact", {
        content_name: "Enquiry Form",
        value: 0, // optional: assign a value if needed
        currency: "INR"
      });
    }

      // Reset fields
      setFname("");
      setLname("");
      setEmail("");
      setPhone("");
      setMsg("");
    } catch (error) {
      console.error("Error sending enquiry:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <section className="contact-con position-relative">
        <div className="container">
          {/* Title */}
          <div className="row">
            <div className="col-12">
              <div className="contact_content text-center" data-aos="fade-up">
                <h2>
                  Get in <span>Touch</span> With Us
                </h2>
                <p>
                  Reach out and connect with us today for any inquiries or
                  assistance!
                </p>
              </div>
            </div>
          </div>

          {/* Tab Buttons */}
          <div className="row mb-4">
            <div className="col-12 text-center">
              {enquiryTabs.map((tab) => (
                <button
                  key={tab}
                  className={`enquiry-tab-btn ${activeTab === tab ? "active" : ""
                    }`}
                  onClick={() => setActiveTab(tab)}
                  type="button"
                  disabled={loading}
                >
                  {tab}
                </button>
              ))}
            </div>
          </div>

          <div className="row">
            {/* Left: Contact Info */}
            <div className="col-lg-4">
              <div className="contact_info">
                <div className="row">
                  <div className="col-12">
                    <div className="contact-box">
                      <figure className="icon mb-0">
                        <img
                          src="./assets/images/contact-icon1.png"
                          alt="image-0"
                          className="img-fluid"
                        />
                      </figure>
                      <div className="content">
                        <h6>Our Location</h6>
                        <a
                          href="https://maps.app.goo.gl/bncLdGUEDrLA9b2V6"
                          className="text-decoration-none text-size-16 mb-0"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Plot No. N 75/1 Additional Anand Nagar MIDC Anand
                          Nagar, East, Ambernath, Maharashtra 421506
                        </a>
                      </div>
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="contact-box">
                      <figure className="icon mb-0">
                        <img
                          src="./assets/images/contact-icon2.png"
                          alt="image-1"
                          className="img-fluid"
                        />
                      </figure>
                      <div className="content">
                        <h6>Phone Number</h6>
                        <a
                          href="tel:+91 9322986301"
                          className="mb-0 text-decoration-none text-size-16"
                        >
                          (+91 9322986301)
                        </a>
                      </div>
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="contact-box mb-0">
                      <figure className="icon mb-0">
                        <img
                          src="./assets/images/contact-icon3.png"
                          alt="image-2"
                          className="img-fluid"
                        />
                      </figure>
                      <div className="content">
                        <h6>Email us at</h6>
                        <a
                          href="mailto:contact@derbyindia.in"
                          className="mb-0 text-decoration-none text-size-16"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          contact@derbyindia.in
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right: Contact Form */}
            <div className="col-lg-8">
              <div className="contact_form">
                <form
                  id="contactpage"
                  onSubmit={handleSubmit}
                  className="position-relative"
                >
                  <div className="form-group">
                    <label>Enquiry Type</label>
                    <input
                      type="text"
                      value={activeTab}
                      readOnly
                      className="form_style"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="fname">First Name</label>
                    <input
                      type="text"
                      className="form_style"
                      name="fname"
                      id="fname"
                      value={fname}
                      onChange={(e) => setFname(e.target.value)}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="lname">Last Name</label>
                    <input
                      type="text"
                      className="form_style"
                      name="lname"
                      id="lname"
                      value={lname}
                      onChange={(e) => setLname(e.target.value)}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="email">Email address</label>
                    <input
                      type="email"
                      className="form_style"
                      name="email"
                      id="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="phone">Phone</label>
                    <input
                      type="tel"
                      className="form_style"
                      name="phone"
                      id="phone"
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                      pattern="[0-9]{10}"
                      required
                      title="Please enter a 10-digit phone number"
                    />
                  </div>

                  <div className="form-group message">
                    <label htmlFor="msg">Message</label>
                    <textarea
                      className="form_style"
                      rows="3"
                      name="msg"
                      id="msg"
                      value={msg}
                      onChange={(e) => setMsg(e.target.value)}
                      required
                    ></textarea>
                  </div>

                  <button
                    type="submit"
                    id="submit"
                    className="submit_now text-decoration-none"
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        Submitting <i className="fa-solid fa-arrow-right"></i>
                      </>
                    ) : (
                      <>
                        Submit Now <i className="fa-solid fa-arrow-right"></i>
                      </>
                    )}

                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CSS for tabs & loader */}
      <style>
        {`
        .enquiry-tab-btn {
          background: #f0f0f0;
          border: none;
          padding: 8px 16px;
          margin: 4px;
          border-radius: 20px;
          cursor: pointer;
          font-size: 14px;
          transition: all 0.3s ease;
        }
        .enquiry-tab-btn.active {
             background: linear-gradient(90deg, #E0A323 0%, #FEBA2A 100%);
          color: #fff;
        }
        .enquiry-tab-btn:hover {
            background: linear-gradient(90deg, #E0A323 0%, #FEBA2A 100%);
          color: #fff;
        }
        .loader {
          border: 2px solid #f3f3f3;
          border-top: 2px solid #fff;
          border-right: 2px solid #fff;
          border-radius: 50%;
          width: 16px;
          height: 16px;
          animation: spin 0.8s linear infinite;
          display: inline-block;
          vertical-align: middle;
        }
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}
      </style>
    </>
  );
};

export default Contactform;
